<header>
	<ng-content select="lvr-basic-layout-header"></ng-content>
</header>
<main>
	<aside>
		<ng-content select="lvr-basic-layout-left"></ng-content>
	</aside>
	<section cdkScrollable>
		<ng-content></ng-content>
	</section>
</main>
